export default function lazyLoad() {
	const images = document.querySelectorAll( "img" );
	for ( let i = 0; i < images.length; ++ i ) {
		let original_image_src = images[i].src;
		if ( !images[i].classList.contains( 'lazy' ) && !images[i].classList.contains( 'no-lazy' ) ) {
			images[i].src = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII=";
			images[i].setAttribute( 'data-src', original_image_src );
			images[i].classList.add( 'lazy' );
		}
	}
}
